import { render, staticRenderFns } from "./blame_header.vue?vue&type=template&id=7a81bb4c&vue3"
import script from "./blame_header.vue?vue&type=script&lang=js&vue3"
export * from "./blame_header.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports